module.exports = __webpack_public_path__ + "static/img/bikes-bg.647e621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bikes-bg.jpg
// module id = 6B8R
// module chunks = 1